import { joinClasses } from '../../primitives/fieldClassSlots';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { LayoutNodeChildProps } from '../nodeRenderProps';
import type { BoxNode } from '../types';
import { RenderNodes } from '../renderNodes';

export function Box({
  node,
  answers,
  repeatBindings,
}: LayoutNodeChildProps<BoxNode>) {
  return (
    <div
      className={joinClasses('min-w-0', node.className)}
      style={layoutInlineStyle(node.style)}
    >
      <RenderNodes
        nodes={node.children}
        answers={answers}
        repeatBindings={repeatBindings}
      />
    </div>
  );
}
